export default
{
	VIDEO_FULLSCREEN: 'videoFullscreen',
	VIDEO_MODAL: 'videoModal'
};